import { render, staticRenderFns } from "./CalcIssueEmailTaxPop.vue?vue&type=template&id=6b0397d1&scoped=true"
import script from "./CalcIssueEmailTaxPop.vue?vue&type=script&lang=js"
export * from "./CalcIssueEmailTaxPop.vue?vue&type=script&lang=js"
import style0 from "./CalcIssueEmailTaxPop.vue?vue&type=style&index=0&id=6b0397d1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0397d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0397d1')) {
      api.createRecord('6b0397d1', component.options)
    } else {
      api.reload('6b0397d1', component.options)
    }
    module.hot.accept("./CalcIssueEmailTaxPop.vue?vue&type=template&id=6b0397d1&scoped=true", function () {
      api.rerender('6b0397d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/popup/CalcIssueEmailTaxPop.vue"
export default component.exports